import React from "react";
// import ReactDOM from "react-dom";
import {hydrate, render} from "react-dom";
// import {loadComponents} from 'loadable-components';
// import {getState} from 'loadable-components/snap';
import JssProvider from 'react-jss/lib/JssProvider';
import {create} from 'jss';
import preset from 'jss-preset-default';
import {Provider} from 'react-redux';
import {createStore, applyMiddleware, compose} from 'redux';
// import {BrowserRouter} from 'react-router-dom';
import {Router} from 'react-router-dom';
import {createBrowserHistory} from 'history';
import promise from 'redux-promise';
import thunk from 'redux-thunk';
import {reactReduxFirebase} from 'react-redux-firebase';
import {persistStore, autoRehydrate} from 'redux-persist';
import firebase from 'firebase/app';
import 'firebase/auth';
import ReactGA from 'react-ga';
// import {MuiThemeProvider} from '@material-ui/core/styles';

import reducers from './reducers';
import registerServiceWorker from './registerServiceWorker';
// import theme from 'themes/main';
// import {UserIsAuthenticated} from 'utils/authRoutes';
import Routes from 'Routes';
import "assets/scss/material-kit-react.css?v=1.1.0";

// TODO QUESTION why doesnt it work when importing the store? figure out later....
// import configureStore from './store';

let fbCreds;
try {
  fbCreds = require('config/firebase').credentials;
} catch (err) {
  const keysInEnv = ('FB_API_KEY' in process.env && 'FB_AUTH_DOMAIN' in process.env && 'GOOGLE_CLOUD_PROJECT' in process.env);
  if (!keysInEnv) {
    fbCreds = {apiKey: 'fb_key_placeholder', authDomain: 'fb_domain_placeholder', projectId: 'fb_proj_id_placeholder'};
  } else {
    fbCreds = {
        apiKey: process.env.FB_API_KEY,
        authDomain: process.env.FB_AUTH_DOMAIN,
        projectId: process.env.GOOGLE_CLOUD_PROJECT,
    };
  }
}

firebase.initializeApp(fbCreds);

// const createStoreWithMiddleware = applyMiddleware(promise, thunk)(createStore);
// // const theme = createMuiTheme();
// const createStoreWithFirebase = compose(
//   reactReduxFirebase(firebase, {}), //TODO QUESTION second arg needed??
// )(createStoreWithMiddleware);

// QUESTION v2react-redux-firebase only works with v4redux-persist? all signs point to yes :/
// TODO update both redux-persist to react-redux-firebase to latest versions!!!
// http://docs.react-redux-firebase.com/history/v2.0.0/docs/integrations/redux-persist.html
const store = createStore(
  reducers,
  compose(
    // reactReduxFirebase(firebase, {reduxConfig}),
    reactReduxFirebase(firebase, {}),
    applyMiddleware(promise, thunk),
    autoRehydrate(),
  )
);
// const store =  configureStore();

const createGenerateClassName = () => {
  let counter = 0
  return (rule, sheet) => `c${Math.random().toString(36).substring(2, 4) + Math.random().toString(36).substring(2, 4)}-${rule.key}-${counter++}`
}

const trackingId = "UA-148014417-1";
ReactGA.initialize(trackingId);
const history = createBrowserHistory();
// Initialize google analytics page view tracking
history.listen(location => {
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
});

const jss = create(preset());
// Custom Material-UI class name generator for better debug and performance.
jss.options.createGenerateClassName = createGenerateClassName;
const curLoc = window.location.pathname;
const isRedirect = (curLoc !== '/404');

const rootElement = document.getElementById("root");
const homePageUrl = "what-is-your-fav-website-1YzP180";
const app = (
  <JssProvider jss={jss}>
    {/* <Provider store={createStoreWithFirebase(reducers)}> */}
    <Provider store={store}>
      <Router history={history}>
        <Routes/>
      </Router>
     </Provider>
   </JssProvider>
);

// NOTE if set back to true, test works with persistStore()
const snap_pre_rendering = false;
if (rootElement.hasChildNodes() && snap_pre_rendering) {
  hydrate(app, rootElement);
  registerServiceWorker();
} else {
  // render(app, rootElement);
  persistStore(store, {}, () => {
    render(app, rootElement);
    registerServiceWorker();
  });
}

// loadComponents().then(() => {
//   render(app, rootElement, () => {
//     Array.from(document.querySelectorAll('[data-jss-snap]')).forEach(elem =>
//       elem.parentNode.removeChild(elem),
//     );
//   });
// });
//
// window.snapSaveState = () => {
//   Array.from(document.querySelectorAll('[data-jss]')).forEach(elem =>
//     elem.setAttribute('data-jss-snap', ''),
//   );
//   return getState();
// };



// WEBPACK FOOTER //
// ./src/index.js